const VIEWED_FEEDS_STORAGE_PREFIX = "care-home-feed-views";
const viewedFeedIdsByKey = new Map();

export const getFeedViewsStorageKey = (userId) =>
  userId
    ? `${VIEWED_FEEDS_STORAGE_PREFIX}-${userId}`
    : VIEWED_FEEDS_STORAGE_PREFIX;

const canUseSessionStorage = () => typeof window !== "undefined";

const ensureViewedFeedIds = (storageKey) => {
  if (!canUseSessionStorage()) return new Set();

  if (!viewedFeedIdsByKey.has(storageKey)) {
    const nextSet = new Set();

    try {
      const storedIds =
        JSON.parse(window.sessionStorage.getItem(storageKey)) ?? [];

      if (Array.isArray(storedIds)) {
        storedIds.forEach((id) => {
          if (id) nextSet.add(id);
        });
      }
    } catch (e) {
      // Ignore storage parsing errors and continue with an empty cache.
    }

    viewedFeedIdsByKey.set(storageKey, nextSet);
  }

  return viewedFeedIdsByKey.get(storageKey);
};

const persistViewedFeedIds = (storageKey) => {
  if (!canUseSessionStorage()) return;

  try {
    const viewedFeedIds = viewedFeedIdsByKey.get(storageKey) ?? new Set();
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify(Array.from(viewedFeedIds)),
    );
  } catch (e) {
    // Ignore storage write errors and rely on in-memory tracking.
  }
};

export const hasRecordedFeedView = (feedId, userId) => {
  const storageKey = getFeedViewsStorageKey(userId);
  return ensureViewedFeedIds(storageKey).has(feedId);
};

export const markFeedViewRecorded = (feedId, userId) => {
  const storageKey = getFeedViewsStorageKey(userId);
  const viewedFeedIds = ensureViewedFeedIds(storageKey);

  viewedFeedIds.add(feedId);
  persistViewedFeedIds(storageKey);
};

export const clearFeedViewTracking = (userId) => {
  if (!canUseSessionStorage()) return;

  const keysToClear = userId
    ? [getFeedViewsStorageKey(userId)]
    : [VIEWED_FEEDS_STORAGE_PREFIX];

  keysToClear.forEach((storageKey) => {
    viewedFeedIdsByKey.delete(storageKey);
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (e) {
      // Ignore storage cleanup errors.
    }
  });
};
